import { type I18n } from '@lingui/core'

import { type CartOverdraftsV2 } from 'types/api/cart'
import TransWithHtml from 'views/components/utils/TransWithHtml'

// because dynamic keys are not supported :/ => https://github.com/RedTecLab/fock/pull/2212#user-content-note-to-all
const groups = [
  /*i18n*/ 'maxdosage.groups.abf_fbe',
  /*i18n*/ 'maxdosage.groups.abfsenngra',
  /*i18n*/ 'maxdosage.groups.abfueh',
  /*i18n*/ 'maxdosage.groups.abfuehgr',
  /*i18n*/ 'maxdosage.groups.abfuehml',
  /*i18n*/ 'maxdosage.groups.abfuehsup',
  /*i18n*/ 'maxdosage.groups.abführklis',
  /*i18n*/ 'maxdosage.groups.abführsenn',
  /*i18n*/ 'maxdosage.groups.abführtabl',
  /*i18n*/ 'maxdosage.groups.abführtrop',
  /*i18n*/ 'maxdosage.groups.abführzäpf',
  /*i18n*/ 'maxdosage.groups.acc',
  /*i18n*/ 'maxdosage.groups.acc_fl',
  /*i18n*/ 'maxdosage.groups.acc_flue',
  /*i18n*/ 'maxdosage.groups.acetylleuc',
  /*i18n*/ 'maxdosage.groups.aciclovir',
  /*i18n*/ 'maxdosage.groups.adenosin',
  /*i18n*/ 'maxdosage.groups.akne',
  /*i18n*/ 'maxdosage.groups.akne2',
  /*i18n*/ 'maxdosage.groups.al_oxid',
  /*i18n*/ 'maxdosage.groups.al_oxid_fl',
  /*i18n*/ 'maxdosage.groups.al_oxidfl',
  /*i18n*/ 'maxdosage.groups.al_oxidgr',
  /*i18n*/ 'maxdosage.groups.alcool',
  /*i18n*/ 'maxdosage.groups.allcromo',
  /*i18n*/ 'maxdosage.groups.alleat_nt',
  /*i18n*/ 'maxdosage.groups.allerexfl',
  /*i18n*/ 'maxdosage.groups.allerg_gr',
  /*i18n*/ 'maxdosage.groups.allergant',
  /*i18n*/ 'maxdosage.groups.allergdcp',
  /*i18n*/ 'maxdosage.groups.allergie',
  /*i18n*/ 'maxdosage.groups.allergiean',
  /*i18n*/ 'maxdosage.groups.allergieex',
  /*i18n*/ 'maxdosage.groups.allergiet',
  /*i18n*/ 'maxdosage.groups.alu_ox_flu',
  /*i18n*/ 'maxdosage.groups.alu_ox_stc',
  /*i18n*/ 'maxdosage.groups.ambrox',
  /*i18n*/ 'maxdosage.groups.ambrox_hal',
  /*i18n*/ 'maxdosage.groups.ambroxo',
  /*i18n*/ 'maxdosage.groups.ambroxol',
  /*i18n*/ 'maxdosage.groups.ambroxol2',
  /*i18n*/ 'maxdosage.groups.amorolfin',
  /*i18n*/ 'maxdosage.groups.anetholtri',
  /*i18n*/ 'maxdosage.groups.antazida',
  /*i18n*/ 'maxdosage.groups.antib2gm',
  /*i18n*/ 'maxdosage.groups.antib2st',
  /*i18n*/ 'maxdosage.groups.antib_as',
  /*i18n*/ 'maxdosage.groups.antib_ex2',
  /*i18n*/ 'maxdosage.groups.antib_ex_g',
  /*i18n*/ 'maxdosage.groups.antib_ext',
  /*i18n*/ 'maxdosage.groups.antib_nas',
  /*i18n*/ 'maxdosage.groups.antibhaut',
  /*i18n*/ 'maxdosage.groups.antibio',
  /*i18n*/ 'maxdosage.groups.antibio_2',
  /*i18n*/ 'maxdosage.groups.antibiot_1',
  /*i18n*/ 'maxdosage.groups.antibiotik',
  /*i18n*/ 'maxdosage.groups.antikoa',
  /*i18n*/ 'maxdosage.groups.antikoag',
  /*i18n*/ 'maxdosage.groups.antisept',
  /*i18n*/ 'maxdosage.groups.antisept_g',
  /*i18n*/ 'maxdosage.groups.ass',
  /*i18n*/ 'maxdosage.groups.beclometh',
  /*i18n*/ 'maxdosage.groups.beclometha',
  /*i18n*/ 'maxdosage.groups.benzylpero',
  /*i18n*/ 'maxdosage.groups.bifonazol',
  /*i18n*/ 'maxdosage.groups.borat',
  /*i18n*/ 'maxdosage.groups.borax',
  /*i18n*/ 'maxdosage.groups.borax_at',
  /*i18n*/ 'maxdosage.groups.brom',
  /*i18n*/ 'maxdosage.groups.bromhex',
  /*i18n*/ 'maxdosage.groups.bromhexfl',
  /*i18n*/ 'maxdosage.groups.carbocyst',
  /*i18n*/ 'maxdosage.groups.carbocyst2',
  /*i18n*/ 'maxdosage.groups.carbocyste',
  /*i18n*/ 'maxdosage.groups.ceter_lora',
  /*i18n*/ 'maxdosage.groups.cetir',
  /*i18n*/ 'maxdosage.groups.cetiriz_fl',
  /*i18n*/ 'maxdosage.groups.cetiriz_tr',
  /*i18n*/ 'maxdosage.groups.cetylpyr',
  /*i18n*/ 'maxdosage.groups.chlorhex',
  /*i18n*/ 'maxdosage.groups.Chlorhexit',
  /*i18n*/ 'maxdosage.groups.ciclopiro2',
  /*i18n*/ 'maxdosage.groups.ciclopirox',
  /*i18n*/ 'maxdosage.groups.ciclospori',
  /*i18n*/ 'maxdosage.groups.cimetidin',
  /*i18n*/ 'maxdosage.groups.cinnar',
  /*i18n*/ 'maxdosage.groups.cinnar_fl',
  /*i18n*/ 'maxdosage.groups.clotrimafr',
  /*i18n*/ 'maxdosage.groups.clotrimazo',
  /*i18n*/ 'maxdosage.groups.clotrimkpg',
  /*i18n*/ 'maxdosage.groups.clotrimvcr',
  /*i18n*/ 'maxdosage.groups.clotrvag',
  /*i18n*/ 'maxdosage.groups.cromoglat',
  /*i18n*/ 'maxdosage.groups.cromogledo',
  /*i18n*/ 'maxdosage.groups.cromogly',
  /*i18n*/ 'maxdosage.groups.crotam',
  /*i18n*/ 'maxdosage.groups.cyprohepta',
  /*i18n*/ 'maxdosage.groups.dexchlorph',
  /*i18n*/ 'maxdosage.groups.dextrome2',
  /*i18n*/ 'maxdosage.groups.dextromet',
  /*i18n*/ 'maxdosage.groups.dextrometh',
  /*i18n*/ 'maxdosage.groups.diclogel',
  /*i18n*/ 'maxdosage.groups.diclogel_',
  /*i18n*/ 'maxdosage.groups.diclopfl',
  /*i18n*/ 'maxdosage.groups.diph_doxyl',
  /*i18n*/ 'maxdosage.groups.doxylamin',
  /*i18n*/ 'maxdosage.groups.durchfall',
  /*i18n*/ 'maxdosage.groups.econa_clot',
  /*i18n*/ 'maxdosage.groups.econazol2',
  /*i18n*/ 'maxdosage.groups.eisen',
  /*i18n*/ 'maxdosage.groups.eisenfl',
  /*i18n*/ 'maxdosage.groups.ephedrin',
  /*i18n*/ 'maxdosage.groups.epilepsie',
  /*i18n*/ 'maxdosage.groups.erdostein',
  /*i18n*/ 'maxdosage.groups.erkälsus',
  /*i18n*/ 'maxdosage.groups.erkältung',
  /*i18n*/ 'maxdosage.groups.erkältung2',
  /*i18n*/ 'maxdosage.groups.etilefrfl',
  /*i18n*/ 'maxdosage.groups.etilefrin',
  /*i18n*/ 'maxdosage.groups.etofenama2',
  /*i18n*/ 'maxdosage.groups.etofenamat',
  /*i18n*/ 'maxdosage.groups.feticonaz2',
  /*i18n*/ 'maxdosage.groups.feticonazo',
  /*i18n*/ 'maxdosage.groups.fexoallerg',
  /*i18n*/ 'maxdosage.groups.flohsambtl',
  /*i18n*/ 'maxdosage.groups.flohsamen',
  /*i18n*/ 'maxdosage.groups.flohsamen2',
  /*i18n*/ 'maxdosage.groups.flubendaz2',
  /*i18n*/ 'maxdosage.groups.flubendazo',
  /*i18n*/ 'maxdosage.groups.fluor',
  /*i18n*/ 'maxdosage.groups.fluor_tab',
  /*i18n*/ 'maxdosage.groups.fluorgel',
  /*i18n*/ 'maxdosage.groups.fluribi',
  /*i18n*/ 'maxdosage.groups.fluribifl',
  /*i18n*/ 'maxdosage.groups.fluribufl',
  /*i18n*/ 'maxdosage.groups.fluribupr',
  /*i18n*/ 'maxdosage.groups.folsäure',
  /*i18n*/ 'maxdosage.groups.glyc_abf',
  /*i18n*/ 'maxdosage.groups.glycerin',
  /*i18n*/ 'maxdosage.groups.glycerinr',
  /*i18n*/ 'maxdosage.groups.glyerin',
  /*i18n*/ 'maxdosage.groups.guafenisin',
  /*i18n*/ 'maxdosage.groups.guaif_sup',
  /*i18n*/ 'maxdosage.groups.guaiffl',
  /*i18n*/ 'maxdosage.groups.h2o2',
  /*i18n*/ 'maxdosage.groups.haar',
  /*i18n*/ 'maxdosage.groups.hals',
  /*i18n*/ 'maxdosage.groups.hals_3',
  /*i18n*/ 'maxdosage.groups.hals_fl',
  /*i18n*/ 'maxdosage.groups.halschmerz',
  /*i18n*/ 'maxdosage.groups.halsentz',
  /*i18n*/ 'maxdosage.groups.halsentz_f',
  /*i18n*/ 'maxdosage.groups.halsentz_g',
  /*i18n*/ 'maxdosage.groups.halsentzml',
  /*i18n*/ 'maxdosage.groups.halsentzu',
  /*i18n*/ 'maxdosage.groups.halsschmer',
  /*i18n*/ 'maxdosage.groups.halsschmerz',
  /*i18n*/ 'maxdosage.groups.halsschmfl',
  /*i18n*/ 'maxdosage.groups.hautpilz',
  /*i18n*/ 'maxdosage.groups.hautpilzf',
  /*i18n*/ 'maxdosage.groups.heparin_at',
  /*i18n*/ 'maxdosage.groups.heparinaug',
  /*i18n*/ 'maxdosage.groups.heptamino2',
  /*i18n*/ 'maxdosage.groups.heptaminol',
  /*i18n*/ 'maxdosage.groups.hustenl',
  /*i18n*/ 'maxdosage.groups.hustenl_fl',
  /*i18n*/ 'maxdosage.groups.hustreiz',
  /*i18n*/ 'maxdosage.groups.hustreizfl',
  /*i18n*/ 'maxdosage.groups.hydroc_ox',
  /*i18n*/ 'maxdosage.groups.hydroco',
  /*i18n*/ 'maxdosage.groups.hydrocort',
  /*i18n*/ 'maxdosage.groups.hydrotalc',
  /*i18n*/ 'maxdosage.groups.hydrotalci',
  /*i18n*/ 'maxdosage.groups.hymecrom',
  /*i18n*/ 'maxdosage.groups.hämmorhsal',
  /*i18n*/ 'maxdosage.groups.hämorrhoid',
  /*i18n*/ 'maxdosage.groups.ibu2',
  /*i18n*/ 'maxdosage.groups.ibu_fl',
  /*i18n*/ 'maxdosage.groups.ibulokal',
  /*i18n*/ 'maxdosage.groups.ibumlg',
  /*i18n*/ 'maxdosage.groups.ibupfl',
  /*i18n*/ 'maxdosage.groups.ibupro',
  /*i18n*/ 'maxdosage.groups.ibuprofe',
  /*i18n*/ 'maxdosage.groups.ibuprofen',
  /*i18n*/ 'maxdosage.groups.ibuprofflu',
  /*i18n*/ 'maxdosage.groups.ibuprofsup',
  /*i18n*/ 'maxdosage.groups.indom',
  /*i18n*/ 'maxdosage.groups.indomet',
  /*i18n*/ 'maxdosage.groups.isocon',
  /*i18n*/ 'maxdosage.groups.isocon_ovu',
  /*i18n*/ 'maxdosage.groups.kalium',
  /*i18n*/ 'maxdosage.groups.ketonaz',
  /*i18n*/ 'maxdosage.groups.ketoprofen',
  /*i18n*/ 'maxdosage.groups.kohle',
  /*i18n*/ 'maxdosage.groups.kohle_gra',
  /*i18n*/ 'maxdosage.groups.kortison',
  /*i18n*/ 'maxdosage.groups.lactulose',
  /*i18n*/ 'maxdosage.groups.lactuloseb',
  /*i18n*/ 'maxdosage.groups.lcabfr_at',
  /*i18n*/ 'maxdosage.groups.levobasaug',
  /*i18n*/ 'maxdosage.groups.levoset',
  /*i18n*/ 'maxdosage.groups.lido_ml',
  /*i18n*/ 'maxdosage.groups.lidoc_be_a',
  /*i18n*/ 'maxdosage.groups.lidoc_l2_2',
  /*i18n*/ 'maxdosage.groups.lidoc_l2_3',
  /*i18n*/ 'maxdosage.groups.lidoc_lok2',
  /*i18n*/ 'maxdosage.groups.lidoc_lok4',
  /*i18n*/ 'maxdosage.groups.lidoc_mu2',
  /*i18n*/ 'maxdosage.groups.lidost',
  /*i18n*/ 'maxdosage.groups.loperam',
  /*i18n*/ 'maxdosage.groups.loperamid',
  /*i18n*/ 'maxdosage.groups.lorat_be',
  /*i18n*/ 'maxdosage.groups.magensrefl',
  /*i18n*/ 'maxdosage.groups.magensrest',
  /*i18n*/ 'maxdosage.groups.malathion',
  /*i18n*/ 'maxdosage.groups.mebendaz_f',
  /*i18n*/ 'maxdosage.groups.mebendazol',
  /*i18n*/ 'maxdosage.groups.mebeverin',
  /*i18n*/ 'maxdosage.groups.meclozin',
  /*i18n*/ 'maxdosage.groups.mephenesin',
  /*i18n*/ 'maxdosage.groups.mephenesor',
  /*i18n*/ 'maxdosage.groups.methocarb',
  /*i18n*/ 'maxdosage.groups.metopimazo',
  /*i18n*/ 'maxdosage.groups.miconazol',
  /*i18n*/ 'maxdosage.groups.miconazvag',
  /*i18n*/ 'maxdosage.groups.minoxidil',
  /*i18n*/ 'maxdosage.groups.muskelschm',
  /*i18n*/ 'maxdosage.groups.naftazon',
  /*i18n*/ 'maxdosage.groups.naftozon',
  /*i18n*/ 'maxdosage.groups.naphazolin',
  /*i18n*/ 'maxdosage.groups.naproxen',
  /*i18n*/ 'maxdosage.groups.nasrst',
  /*i18n*/ 'maxdosage.groups.nicotin',
  /*i18n*/ 'maxdosage.groups.nicotin2',
  /*i18n*/ 'maxdosage.groups.nicotpfl',
  /*i18n*/ 'maxdosage.groups.niflu_idro',
  /*i18n*/ 'maxdosage.groups.nifu_race',
  /*i18n*/ 'maxdosage.groups.nikotin',
  /*i18n*/ 'maxdosage.groups.nikotin_2',
  /*i18n*/ 'maxdosage.groups.nikotinpfl',
  /*i18n*/ 'maxdosage.groups.noscapin',
  /*i18n*/ 'maxdosage.groups.nsar_1gr',
  /*i18n*/ 'maxdosage.groups.nsar_1st',
  /*i18n*/ 'maxdosage.groups.nsar_1sup',
  /*i18n*/ 'maxdosage.groups.nsar_2gr',
  /*i18n*/ 'maxdosage.groups.nsar_2ml',
  /*i18n*/ 'maxdosage.groups.nsar_2st',
  /*i18n*/ 'maxdosage.groups.nsarfl',
  /*i18n*/ 'maxdosage.groups.nsargr',
  /*i18n*/ 'maxdosage.groups.omepr',
  /*i18n*/ 'maxdosage.groups.opiatmlg',
  /*i18n*/ 'maxdosage.groups.opiatst',
  /*i18n*/ 'maxdosage.groups.orlist',
  /*i18n*/ 'maxdosage.groups.orlista_it',
  /*i18n*/ 'maxdosage.groups.orlistat',
  /*i18n*/ 'maxdosage.groups.oxeladin',
  /*i18n*/ 'maxdosage.groups.oxytetr_ex',
  /*i18n*/ 'maxdosage.groups.oxytetrac',
  /*i18n*/ 'maxdosage.groups.panto',
  /*i18n*/ 'maxdosage.groups.paracet',
  /*i18n*/ 'maxdosage.groups.paraceta',
  /*i18n*/ 'maxdosage.groups.paracetamo',
  /*i18n*/ 'maxdosage.groups.paracetrx',
  /*i18n*/ 'maxdosage.groups.paraff',
  /*i18n*/ 'maxdosage.groups.paraffin',
  /*i18n*/ 'maxdosage.groups.paraffin2',
  /*i18n*/ 'maxdosage.groups.parasiten',
  /*i18n*/ 'maxdosage.groups.pcm',
  /*i18n*/ 'maxdosage.groups.pcm_cod',
  /*i18n*/ 'maxdosage.groups.pcm_cod_su',
  /*i18n*/ 'maxdosage.groups.pcm_fl',
  /*i18n*/ 'maxdosage.groups.pcm_pseph',
  /*i18n*/ 'maxdosage.groups.pcmflüss',
  /*i18n*/ 'maxdosage.groups.pcmkomb',
  /*i18n*/ 'maxdosage.groups.pcmkombi',
  /*i18n*/ 'maxdosage.groups.pcmsup',
  /*i18n*/ 'maxdosage.groups.pentofuryl',
  /*i18n*/ 'maxdosage.groups.phlorogluc',
  /*i18n*/ 'maxdosage.groups.picloxydin',
  /*i18n*/ 'maxdosage.groups.pille_dafr',
  /*i18n*/ 'maxdosage.groups.pille_dana',
  /*i18n*/ 'maxdosage.groups.pilocarp',
  /*i18n*/ 'maxdosage.groups.pilocarpin',
  /*i18n*/ 'maxdosage.groups.pilz2vagst',
  /*i18n*/ 'maxdosage.groups.pilz_2gr',
  /*i18n*/ 'maxdosage.groups.pilz_2ml',
  /*i18n*/ 'maxdosage.groups.pilz_vt',
  /*i18n*/ 'maxdosage.groups.pilzgr',
  /*i18n*/ 'maxdosage.groups.pilzml',
  /*i18n*/ 'maxdosage.groups.pilzvag',
  /*i18n*/ 'maxdosage.groups.progestero',
  /*i18n*/ 'maxdosage.groups.promethazi',
  /*i18n*/ 'maxdosage.groups.psephkombi',
  /*i18n*/ 'maxdosage.groups.pseudoephe',
  /*i18n*/ 'maxdosage.groups.pyrethin',
  /*i18n*/ 'maxdosage.groups.racecadotr',
  /*i18n*/ 'maxdosage.groups.ranitidin',
  /*i18n*/ 'maxdosage.groups.schlaf',
  /*i18n*/ 'maxdosage.groups.schleimfl',
  /*i18n*/ 'maxdosage.groups.schleimlös',
  /*i18n*/ 'maxdosage.groups.schmerzen1',
  /*i18n*/ 'maxdosage.groups.schmerzen2',
  /*i18n*/ 'maxdosage.groups.schmerzen3',
  /*i18n*/ 'maxdosage.groups.schmerzen5',
  /*i18n*/ 'maxdosage.groups.schmerzfl',
  /*i18n*/ 'maxdosage.groups.schmerzpfl',
  /*i18n*/ 'maxdosage.groups.schmerzst',
  /*i18n*/ 'maxdosage.groups.schmerzsup',
  /*i18n*/ 'maxdosage.groups.schnupf',
  /*i18n*/ 'maxdosage.groups.schnupfen',
  /*i18n*/ 'maxdosage.groups.silbersulf',
  /*i18n*/ 'maxdosage.groups.singletonProduct',
  /*i18n*/ 'maxdosage.groups.spasmolyt',
  /*i18n*/ 'maxdosage.groups.sucralfat',
  /*i18n*/ 'maxdosage.groups.tah',
  /*i18n*/ 'maxdosage.groups.terbinafin',
  /*i18n*/ 'maxdosage.groups.tetryzol',
  /*i18n*/ 'maxdosage.groups.theophyl',
  /*i18n*/ 'maxdosage.groups.triamcinol',
  /*i18n*/ 'maxdosage.groups.triclocab2',
  /*i18n*/ 'maxdosage.groups.triclocaba',
  /*i18n*/ 'maxdosage.groups.trimebrut',
  /*i18n*/ 'maxdosage.groups.trimébutin',
  /*i18n*/ 'maxdosage.groups.triptane',
  /*i18n*/ 'maxdosage.groups.vaprino',
  /*i18n*/ 'maxdosage.groups.vit_b',
  /*i18n*/ 'maxdosage.groups.vit_b_fl',
  /*i18n*/ 'maxdosage.groups.vit_d_fl',
  /*i18n*/ 'maxdosage.groups.vit_d_st',
  /*i18n*/ 'maxdosage.groups.vitamd3fl',
  /*i18n*/ 'maxdosage.groups.vitamind3',
  /*i18n*/ 'maxdosage.groups.vitd',
  /*i18n*/ 'maxdosage.groups.vitd_st',
]

const attributes = [
  /*i18n*/ 'product.attribute.unit.pcs',
  /*i18n*/ 'product.attribute.unit.ml',
  /*i18n*/ 'product.attribute.unit.g',
  /*i18n*/ 'product.attribute.unit.package',
]
/**
 * @param {*} overdraft
 * @param {number} maxDosageHistory
 * @param {I18n} i18n Lingui translation instance
 * @returns translated Message or generic message if key is not found by lingui
 */
export const translateKeys = (overdraft: CartOverdraftsV2, i18n: I18n) => {
  if (groups.includes(overdraft.name) && attributes.includes(overdraft.unit)) {
    return overdraft.purchaseHistoryOverdraft ? (
      <TransWithHtml
        text={i18n._(
          'cart.notification.maxDosageWithCph.productInfo.withHistory',
          {
            name: i18n._(overdraft.name),
            currentDosage: overdraft.currentDosage,
            maxDosage: overdraft.maxDosage,
            unit: i18n._(overdraft.unit),
          }
        )}
      />
    ) : (
      <TransWithHtml
        text={i18n._('cart.notification.maxDosage.productInfo.noHistory', {
          name: i18n._(overdraft.name),
          currentDosage: overdraft.currentDosage,
          maxDosage: overdraft.maxDosage,
          unit: i18n._(overdraft.unit),
        })}
      />
    )
  }
}
